// extracted by mini-css-extract-plugin
export default {"wrapper-image-technology":"TechnologyImage_wrapper-image-technology__y+MEl"};